import React, { useState, useEffect, useRef } from "react";
import { SeatingForm } from "./SeatingForm";
import { CommonErrorMsg, ErrorMsg, ValidateForm } from "../../Util/common";
import { generateGuid } from "../../Kendo/kendo_common";
import { KendoGrid } from "../../Kendo/kendo_grid";

export const FeaturesForm = ({
  facilityDetails,
  setFacilityDetails,
  goNext,
  goBack,
}) => {
  const [FeaturesForm, setFeaturesForm] = useState({
    FeaturesID: 0,
    Caption: "",
    Value: "",
    FacilityID: 0,
    SavedBy: 0,
  });
  const captionRef = useRef(null);
  const valueRef = useRef(null);
  useEffect(() => {}, [facilityDetails]);
  const clearForm = () => {
    setFeaturesForm({
      FeaturesID: 0,
      Caption: "",
      Value: "",
      FacilityID: 0,
      SavedBy: 0,
    });
    setError({});
    setEditVisible(false);
    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const [removedVirtualMappingIds, setRemovedVirtualMappingIds] = useState("");

  const [FeaturesFormList, setFeaturesFormList] = useState([]);

  const [editVisible, setEditVisible] = useState(false);

  const [error, setError] = useState({});

  useEffect(() => {
    if (facilityDetails != null && facilityDetails.Features != null) {
      setFeaturesForm(facilityDetails.Features);
      setFeaturesFormList(facilityDetails.Features);
    }
  }, [facilityDetails]);
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const onFeaturesFormSubmit = (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
      return;
    }

    setError({ EmptyList: false });

    const newRow = {
      ...FeaturesForm,
      guid: FeaturesForm.guid || generateGuid(),
      savedBy: 0,
      facilityID: 0,
      caption: FeaturesForm.Caption,
      value: FeaturesForm.Value,
      featuresID:
        FeaturesForm.FeaturesID > 0
          ? FeaturesForm.FeaturesID
          : FeaturesForm.guid || generateGuid(),
    };

    if (newRow.featuresID > 0) {
      const updatedList = FeaturesFormList.map((item) =>
        item.featuresID === newRow.featuresID ? newRow : item
      );
      setFeaturesFormList(updatedList);
    } else if (newRow.guid) {
      const existingRow = FeaturesFormList.find(
        (item) => item.guid === newRow.guid
      );
      if (existingRow) {
        const updatedList = FeaturesFormList.map((item) =>
          item.guid === newRow.guid ? newRow : item
        );
        setFeaturesFormList(updatedList);
      } else {
        setFeaturesFormList((prevList) => [...prevList, newRow]);
      }
    } else {
      setFeaturesFormList((prevList) => [...prevList, newRow]);
    }
    clearForm();
  };
  const [removedFeatureIds, setRemovedFeatureIds] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (FeaturesFormList.length === 0) {
      setError({ EmptyList: true });
      return;
    }
    console.log(facilityDetails);

    setFacilityDetails((prev) => ({
      ...prev,
      Features: FeaturesFormList,
      removedFeatureIds,
    }));
    goNext();
  };

  const handleFeaturesAddDeleteClick = (e) => {
    const index = FeaturesFormList.findIndex((item) =>
      e.featuresID ? item.featuresID === e.featuresID : item.guid === e.guid
    );

    if (index !== -1) {
      const temp = [...FeaturesFormList];

      if (temp[index].featuresID) {
        setRemovedFeatureIds((prev) =>
          prev
            ? `${prev},${temp[index].featuresID}`
            : `${temp[index].featuresID}`
        );
      }

      // Remove the feature item
      const updatedList = temp.filter((_, i) => i !== index);
      setFeaturesFormList(updatedList);
    }
  };

  const handleFeaturesEditClick = (e) => {
    // Find the row to edit based on `featuresID` or `guid`
    const rowToEdit = FeaturesFormList.find((item) =>
      e.featuresID > 0 ? item.featuresID === e.featuresID : item.guid === e.guid
    );

    if (rowToEdit) {
      setFeaturesForm({
        ...rowToEdit,
        Caption: rowToEdit.caption,
        Value: rowToEdit.value,
        FeaturesID:
          rowToEdit.featuresID > 0 ? rowToEdit.featuresID : rowToEdit.guid,
        FacilityID: rowToEdit.facilityID || "", // Add if necessary
      });

      setEditVisible(true);
      captionRef.current.focus();
    }
  };

  return (
    <div>
      <form onSubmit={onFeaturesFormSubmit}>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Caption <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={100}
              className="form-control field"
              name="Caption"
              value={FeaturesForm.Caption}
              placeholder="Caption"
              data-required="true"
              onChange={(e) => {
                setFeaturesForm((prev) => ({
                  ...prev,
                  Caption: e.target.value,
                }));
                onValidation("Caption", e.target.value);
              }}
              ref={captionRef}
            />
            <CommonErrorMsg
              text="Caption is required"
              IsError={error.Caption}
            />
            {/* {error.Caption && <ErrorMsg text="Caption is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Value <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={100}
              className="form-control field"
              name="Value"
              value={FeaturesForm.Value}
              placeholder="Value"
              data-required="true"
              onChange={(e) => {
                setFeaturesForm((prev) => ({
                  ...prev,
                  Value: e.target.value,
                }));
                onValidation("Value", e.target.value);
              }}
              ref={valueRef}
            />
            <CommonErrorMsg text="Value is required" IsError={error.Value} />

            <CommonErrorMsg
              text="Please add at least one Feature"
              IsError={error.EmptyList}
            />
          </div>
          <div className="col-md-2 mb-3">
            <button
              type="submit"
              className="btn btn-primary mt-3"
              title="Add Features"
            >
              <i className="las la-plus-circle"></i>
            </button>
          </div>
        </div>
      </form>
      <form id="subgrid-form" onSubmit={onSubmit}>
        <div className="col-md-12 mb-3" style={{ textAlign: "right" }}>
          <button
            type="button"
            className="butn-dark2 grey-btn m-2"
            // style={{ marginLeft: "5px" }}
            onClick={goBack}
          >
            <span>Back</span>
          </button>
          <button type="submit" className="butn-dark2">
            <span>Next</span>
          </button>
        </div>
        {FeaturesFormList.length > 0 && (
          <KendoGrid
            name={"homeBannerSubGrid"}
            disableToolbar={true}
            paggable={true}
            data={FeaturesFormList}
            columns={[
              {
                field: "featuresID",
                hidden: true,
              },
              {
                field: "guid",
                hidden: true,
              },
              {
                field: "primaryId",
                hidden: true,
              },

              {
                field: "facilityID",
                hidden: true,
              },
              {
                field: "caption",
                title: "Caption",
              },
              {
                field: "value",
                title: "Value",
              },
            ]}
            showOptions={true}
            showDelete={true}
            showEdit={true}
            onEditClick={(e) => handleFeaturesEditClick(e)}
            onDeleteClick={(e) => handleFeaturesAddDeleteClick(e)}
            refreshWhen={FeaturesFormList.length}
          />
        )}
      </form>
    </div>
  );
};
